import { RouterProvider } from 'react-router-dom';
import { router } from '@/presentation/router/routes';

export const App = () => {
  return <RouterProvider router={router} />;
};
